import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { Insight } from "models/insight";
import { twMerge } from "tailwind-merge";

import useAuthentication from "hooks/useAuthentication";

import RelatedInsightsList from "./RelatedInsightsList";

const InsightRelatedContentV2 = ({ insight }: { insight: Insight }) => {
  const { t } = useTranslation();

  const { authenticated, account: loggedInAccount } = useAuthentication();

  const { entity } = insight;

  const sections = useMemo(() => {
    return [
      ...(entity
        ? [
            {
              id: "related",
              name: t("Related Insights"),
            },
          ]
        : []),
      {
        id: "top-collection",
        name: t("Trending Collections"),
        ordered: true,
        columns: 2,
      },
      {
        id: "trending",
        name: t("Trending Insights"),
        ordered: true,
      },
      ...(!authenticated || loggedInAccount?.isPreviewPass
        ? [
            {
              id: "unpaywalled",
              name: t("Top Unpaywalled Insights"),
              ordered: true,
            },
          ]
        : []),
    ];
  }, [authenticated, entity, loggedInAccount?.isPreviewPass, t]);

  return (
    <div className="flex flex-wrap m-[-25px] pt-[30px]">
      {sections.map((section, index) => (
        <div
          key={section.id}
          className={twMerge(
            "basis-[100%]",
            sections.length % 2 === 1 && index === sections.length - 1
              ? ""
              : "md:basis-[50%]",
            "p-[25px]"
          )}
        >
          <RelatedInsightsList insight={insight} section={section} />
        </div>
      ))}
    </div>
  );
};

export default InsightRelatedContentV2;
